package com.crowpay.views.components

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.actuals.rotation
import com.crowpay.chevronUp
import com.crowpay.sdk.UnreadHandler
import com.crowpay.utils.empty
import com.crowpay.views.theming.ExpandButtonSemantic
import com.crowpay.views.theming.SectionSemantic
import com.lightningkite.kiteui.AppScope
import com.lightningkite.kiteui.models.Angle
import com.lightningkite.kiteui.models.Dimension
import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.models.px
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.RView
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.dynamicTheme
import kotlinx.coroutines.launch
import kotlin.time.Duration.Companion.milliseconds

fun RView.expandIcon(expanded: Readable<Boolean>, extraSetup: RView.() -> Unit = {}) = icon {
    source = Icon.chevronUp
    ::rotation { if (expanded()) Angle.zero else Angle.halfTurn }
    ::description { if (expanded()) "collapse" else "expand" }
    extraSetup()
}


fun RView.expandIcon(expanded: ReactiveContext.() -> Boolean) =
    icon {
        source = Icon.chevronUp
        ::description { if (expanded()) "collapse" else "expand" }
        ::rotation { if (expanded()) Angle.zero else Angle.halfTurn }
    }

fun expandAction(expanded: Writable<Boolean>) = Action("Toggle Expanded", icon = Icon.empty, frequencyCap = 100.milliseconds, action = expanded::toggle)

fun expandAndDelayMarkAsReadAction(expanded: Writable<Boolean>, update: suspend () -> (() -> Unit)?): Action {
    var localUpdate: (() -> Unit)? = null
    return Action("Expand and mark as read on close", icon = Icon.empty, frequencyCap = 200.milliseconds) {
        val willExpand = !expanded()
        if (willExpand) {
            AppScope.launch { localUpdate = update() }
        }
        else {
            localUpdate?.invoke()
            localUpdate = null
        }
        expanded.set(willExpand)
    }
}

fun expandAndMarkAsReadAction(expanded: Writable<Boolean>, unread: Readable<UnreadHandler>): Action {
    var localUpdate: (() -> Unit)? = null
    return Action("Expand and mark as read on close", icon = Icon.empty, frequencyCap = 200.milliseconds) {
        val willExpand = !expanded()
        if (willExpand) {
            AppScope.launch {
                val u = unread()

                u.markRead?.invoke()
                localUpdate = u.markReadDelayUpdate?.invoke()
            }
        }
        else {
            localUpdate?.invoke()
            localUpdate = null
        }
        expanded.set(willExpand)
    }
}

fun RView.expandButton(expanded: Writable<Boolean>, customAction: Action? = null, contents: RView.() -> Unit) {
    ExpandButtonSemantic.onNext - button {
        spacing = 0.px
        row {
            spacing = AppDimensions.expandButtonSpace
            this@row.contents()
            centered - expandIcon(expanded)
        }
        action = customAction ?: expandAction(expanded)
    }
}

fun RView.leftExpandButton(
    expanded: Writable<Boolean>,
    highlightOnExpand: Boolean = true,
    padding: Dimension = AppDimensions.cornerRadii,
    customAction: Action? = null,
    unread: (ReactiveContext.() -> Boolean)? = null,
    contents: RView.() -> Unit
) =
    ExpandButtonSemantic.onNext - button {
        if (highlightOnExpand) dynamicTheme {
            if (expanded()) SectionSemantic else null
        }
        spacing = padding
        row {
            spacing = AppDimensions.expandButtonSpace
            if (unread != null) centered - unreadIconVisible { unread() }
            centered - expandIcon(expanded)
            centered - this@row.contents()
        }
        action = customAction ?: expandAction(expanded)
    }

fun RView.leftExpandButtonWithUnread(
    expanded: Writable<Boolean>,
    unread: Readable<UnreadHandler>,
    highlightOnExpand: Boolean = true,
    padding: Dimension = AppDimensions.cornerRadii,
    contents: RView.() -> Unit
) =
    ExpandButtonSemantic.onNext - button {
        if (highlightOnExpand) dynamicTheme {
            if (expanded()) SectionSemantic else null
        }
        spacing = padding
        row {
            spacing = AppDimensions.expandButtonSpace
            centered - unreadIconVisible { unread()() }
            centered - expandIcon(expanded)
            centered - this@row.contents()
        }
        action = expandAndMarkAsReadAction(expanded, unread)
    }